export default "__VITE_ASSET__BIBykriS__"